module.exports = __webpack_public_path__ + "static/media/archiveBlue.84db2ba7.svg";